import React from 'react';
import {Route, Routes,} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import {useQuery} from "@tanstack/react-query";

import Homepage from "./Store/Homepage";
import NavbarBottom from "../Components/Sections/NavbarBottom";
import {setStore, updateIsInCustomerMode} from "../features/store/storeSlice";
import Agent from "../Network/Agent";
import {RouteEnumFinal} from "../Config/RouteEnum";
import {getStoreName} from "../Components/Utils/getStoreName";
import Panel from "./Store/Panel/Panel";
import Profile from "./Store/Profile/Profile";


const MainView = () => {

    const {isInCustomerMode} = useSelector((state) => state.store);
    const dispatch = useDispatch()

    const { data: store, isLoading} = useQuery({
        queryKey: ['store', getStoreName()],
        queryFn: async () => {
            try {
                const response = await Agent.Store.getByUsername(getStoreName());
                const storeData = response.data.result.store;

                dispatch(setStore(storeData));
                if (storeData?.isOwner) {
                    dispatch(updateIsInCustomerMode(false))
                }

                return storeData;
            } catch (error) {
                console.error('Error fetching store:', error);
                throw error;
            }
        }
    });



    return (
        <>
            <Routes>
                <Route path={RouteEnumFinal.STORE_PANEL}
                       element={<Panel />} />

                <Route path={RouteEnumFinal.STORE_MAIN_VIEW}
                       element={<Homepage store={store} isFetching={isLoading}/>} />

                <Route path={RouteEnumFinal.USER_PROFILE}
                       element={<Profile />} />
            </Routes>

            {
                !isInCustomerMode && <NavbarBottom firstCategoryCode={store?.firstCategory} />
            }
        </>
    );
}


export default MainView